module.exports = __webpack_public_path__ + "img/mastercard.ec8903d9.jpg";